import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { KitContents } from './components/KitContents';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { FinalOffer } from './components/FinalOffer';
import { FAQ } from './components/FAQ';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  // Meta Pixel Injection
  useEffect(() => {
    const pixelId = '1252242806993118';
    // Inject script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Inject noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      // Cleanup if needed
      document.head.removeChild(script);
      document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen relative font-sans selection:bg-teal-200 selection:text-teal-900" data-id="element-0">
      {/* Background with blur effect */}
      <div className="fixed inset-0 z-[-1] bg-[url('https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=2053&auto=format&fit=crop')] bg-cover bg-center bg-fixed" data-id="element-1">
        <div className="absolute inset-0 bg-slate-900/55 backdrop-blur-[3px]" data-id="element-2"></div>
      </div>

      {/* Main Content */}
      <main className="w-full" data-id="element-3">
        <Hero data-id="element-4" />
        <Problems data-id="element-5" />
        <KitContents data-id="element-6" />
        <Testimonials data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Comparison data-id="element-9" />
        <FinalOffer data-id="element-10" />
        <FAQ data-id="element-11" />
      </main>

      <PurchasePopup data-id="element-12" />
    </div>;
}